import React, { useContext } from 'react';
import { ToastContext } from '@signavio/ui/core';
import { PropsDecoratorContext } from 'substyle';
import { PortalContext } from 'react-stick';
import { writeCookie, readCookie } from './cookie';
const COOKIE_NAME = 'signavio_mfe_chunk_load_retry';
function lazy(importCallback, remotePath) {
  const dummyMfe = () => null;
  dummyMfe.mfeVersion = 1;
  return /*#__PURE__*/React.lazy(async () => {
    const {
      default: ProvidedMfe
    } = await importCallback().catch(async error => {
      if (error.name !== 'ChunkLoadError') {
        throw error;
      }

      // Loading the remote chunk failed.
      // First, check if the remote service is available.
      if (remotePath) {
        await fetch(remotePath, {
          mode: 'no-cors'
        });
      }

      // If we get here, the remote service might be available.

      // Second, make sure we are not already in retry to prevent an infinite page reloading loop.
      if (readCookie(COOKIE_NAME) === 'true') {
        throw new Error(`ChunkLoadError even on retry: ${error.message}`);
      }

      // Set a cookie that expires in 30s, so we know we are reloading
      writeCookie(COOKIE_NAME, 'true', new Date(Date.now() + 30 * 1000));

      // Force page reload
      window.location.reload();

      // Return something to prevent other downstream errors
      return {
        default: dummyMfe
      };
    });
    const LazyMfe = props => {
      const toastContext = useContext(ToastContext);
      const portalContext = useContext(PortalContext);
      const propsDecoratorContext = useContext(PropsDecoratorContext);
      if (ProvidedMfe.mfeVersion !== 1) {
        // backwards compatibility: the MFE is still not wrapped with provide() yet
        const LegacyMfe = ProvidedMfe;
        return /*#__PURE__*/React.createElement(LegacyMfe, props);
      }
      return /*#__PURE__*/React.createElement(ProvidedMfe, {
        props: props,
        toastContext,
        portalContext,
        propsDecoratorContext
      });
    };
    return {
      default: LazyMfe
    };
  });
}
export default lazy;
//# sourceMappingURL=lazy.js.map